<template>
  <v-card class="common-card">
    <v-col xl="12" lg="12" md="12" sm="12" xs="12">
      <div class="image_succsecc">
        <img width="350" src="../../assets/images/Unsuccessful.svg" alt="" />
      </div>
    </v-col>
    <v-col xl="12" lg="12" md="12" sm="12" xs="12">
      <div class="d-flex justify-center">
        <span class="font-weight-bold fs-large mainFont--text"
          >پرداخت شما ناموفق بود.</span
        >
      </div>
    </v-col>
    <v-row>
      <v-col xl="5" lg="4" md="4" sm="3" xs="12" cols="12"></v-col>
      <v-col xl="2" lg="4" md="4" sm="6" xs="12" cols="12">
        <div class="text-center">
          <v-btn
            class="purple-borderedBtn"
            width="100%"
            height="48"
            @click="backToCart()"
          >
            تلاش مجدد
          </v-btn>
        </div>
      </v-col>
      <v-col xl="5" lg="4" md="4" sm="3" xs="12" cols="12"></v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      invoiceCode: "",
    };
  },
  methods: {
    ...mapMutations(["setInCart"]),
    backToCart() {
      this.$router.push("/checkout/cart");
    },
  },
  mounted() {
    if (!localStorage.getItem("shopToken")) {
      this.$router.push("/main");
      this.toast("ابتدا لاگین کنید", "error");
    } else {
      // this.invoiceCode = localStorage.getItem("invoiceCode");
      this.invoiceCode = this.$route.query.invoiceCode;
    }
  },
};
</script>

<style lang="scss">
.image_succsecc {
  width: 350px;
  margin: auto;
  img {
    width: 100%;
  }
}
</style>
